import type { PageMeta } from "./en";

export const enVrat: Record<string, PageMeta> = {
  ekadashi: {
    title: "Ekadashi {year} — Dates, Vrat Rules, Paaran Time & Puja Vidhi | Ishvaram",
    description:
      "Ekadashi {year} & {nextyear} dates — full vrat (fasting) rules, paaran timing, Vishnu puja vidhi and upay.",
  },
  amavasya: {
    title: "Amavasya {year} — Dates, Pitru Tarpan, Shradh & Puja Vidhi | Ishvaram",
    description:
      "Amavasya {year} & {nextyear} dates — new moon meaning, Pitru Tarpan & Shradh vidhi, Mahalaya & Mauni Amavasya, and upay for Pitra Dosh.",
  },
  purnima: {
    title: "Purnima {year} — Dates, Satyanarayan Vrat & Puja Vidhi | Ishvaram",
    description:
      "Purnima {year} & {nextyear} dates — full moon meaning, Satyanarayan vrat rules & puja vidhi, Guru, Sharad & Kartik Purnima, plus upay for an unsettled Moon.",
  },
  pradosh: {
    title: "Pradosh Vrat {year} — Dates, Trayodashi, Shiva Puja Vidhi | Ishvaram",
    description:
      "Pradosh Vrat {year} & {nextyear} dates — Trayodashi meaning, Som, Bhaum & Shani Pradosh, Shiva puja vidhi, and upay for Shani dosha.",
  },
  "sankashti-chaturthi": {
    title: "Sankashti Chaturthi {year} — Dates, Vrat, Moonrise & Ganesh Puja Vidhi | Ishvaram",
    description:
      "Sankashti Chaturthi {year} & {nextyear} dates — Chaturthi vrat & moonrise (Chandra Darshan) rules, Ganesh puja vidhi, Angarki, and upay for blocked work.",
  },
  "masik-shivratri": {
    title: "Masik Shivratri {year} — Dates, Vrat, Night Vigil & Shiva Puja Vidhi | Ishvaram",
    description:
      "Masik Shivratri {year} & {nextyear} dates — Chaturdashi vrat and night-vigil rules, Shiva puja vidhi and abhishek, and how it differs from Maha Shivratri.",
  },
  sankranti: {
    title: "Sankranti {year} — All 12 Sankranti Dates, Makar Sankranti & Puja Vidhi | Ishvaram",
    description:
      "Sankranti {year} & {nextyear} dates for all 12 solar Sankrantis — Makar Sankranti and Uttarayan, snan-daan punya kaal, and what each one means for you.",
  },
  "vrat-calendar": {
    title: "Vrat Calendar {year} — Hindu Vrat & Fast Dates, Ekadashi to Sankranti | Ishvaram",
    description:
      "Hindu vrat calendar {year}: the next date of Ekadashi, Purnima, Amavasya, Pradosh, Sankashti, Masik Shivratri and Sankranti, with puja vidhi links.",
  },
};
